import { useQuery } from '@tanstack/react-query';

import { persistedQueryConfig } from '@/utilities/persistQueryClient/utilities';

import selector from './selector';
import queryFn from './queryFn';
import { QUERY_KEY } from './utils';

type Args = {
  enabled?: boolean;
};

export default function useRecentlyViewedCompanies(
  { enabled }: Args = { enabled: true }
) {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn,
    select: selector,
    enabled,
    ...persistedQueryConfig,
  });
}
